import {
  useEffect,
} from "react";
import {
  OnboardingEvents,
  trackEvent,
} from "../analytics/posthog";
import {
  IMessageDeepLinkPairing,
} from "./pairing/IMessageDeepLinkPairing";

interface IMessagePairingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAttemptStarted?: (expiresAt: string) => void;
  onSuccess: () => void;
}

/**
 * Pairs iMessage by deep link, on every platform, with no way back to a
 * texted code: Linq's guidance is that a number which sends the first message
 * in a thread is what gets it flagged, so the outbound code send is the thing
 * this flow exists to remove, not an alternative to offer. Desktops without a
 * Messages app get a QR code and the text to send by hand inside the same
 * flow.
 *
 * `imessage_modal_opened` fires here, once per open.
 */
export function IMessagePairingModal({
  isOpen,
  onClose,
  onAttemptStarted,
  onSuccess,
}: IMessagePairingModalProps) {
  useEffect(() => {
    if (isOpen) trackEvent(OnboardingEvents.IMESSAGE_MODAL_OPENED);
  }, [isOpen]);

  // Spread rather than passed: under exactOptionalPropertyTypes an explicit
  // `undefined` is not the same as an absent optional prop.
  const attempt = onAttemptStarted ? { onAttemptStarted } : {};

  return (
    <IMessageDeepLinkPairing
      isOpen={isOpen}
      onClose={onClose}
      onSuccess={onSuccess}
      {...attempt}
    />
  );
}
